import { render, staticRenderFns } from "./warehouseFlow.vue?vue&type=template&id=1bcaf218&scoped=true&"
import script from "./warehouseFlow.vue?vue&type=script&lang=js&"
export * from "./warehouseFlow.vue?vue&type=script&lang=js&"
import style0 from "./warehouseFlow.vue?vue&type=style&index=0&id=1bcaf218&prod&rel=stylesheet%2Fscss&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bcaf218",
  null
  
)

export default component.exports